/* assets/component-card-product-result.js */

(function () {
  if (window.__cardProblemSolutionToggleInit) return;
  window.__cardProblemSolutionToggleInit = true;

  function initCard(root) {
    if (!root || root.dataset.beforeAfterInit === 'true') return;

    const button = root.querySelector('[data-problem-solution-toggle]'),
          beforeLabel = button.dataset.before || 'Before',
          afterLabel = button.dataset.after || 'After',
          beforeImage = root.querySelector('[data-before-image]'),
          afterImage = root.querySelector('[data-after-image]');

    root.dataset.beforeAfterInit = 'true';

    function knobTravelPx() {
      var knob = button.querySelector('.card__floating-toggle__knob');
      if (!knob) return 0;

      // Compute available inner width of the track = content box (clientWidth) minus paddings
      var styles = getComputedStyle(button);
      var padL = parseFloat(styles.paddingLeft) || 0;
      var padR = parseFloat(styles.paddingRight) || 0;
      var inner = button.clientWidth - padL - padR;

      // Distance the knob should travel = inner width minus knob width
      var travel = inner - knob.offsetWidth;
      return Math.max(0, travel);
    }

    function setState(showAfter) {
      // Content visibility
      if (showAfter) {
        beforeImage.setAttribute('hidden', '');
        afterImage.removeAttribute('hidden');
      } else {
        afterImage.setAttribute('hidden', '');
        beforeImage.removeAttribute('hidden');
      }

      // Update ARIA + visual state class
      button.setAttribute('aria-pressed', showAfter ? 'true' : 'false');
      button.setAttribute('aria-label', showAfter ? afterLabel : beforeLabel);
      button.classList.toggle('is-on', !!showAfter);

      // Animate knob by transform (CSS has transition for smooth motion)
      var knob = button.querySelector('.card__floating-toggle__knob');
      if (knob) {
        var travel = knobTravelPx();
        knob.style.setProperty('--knob-x', showAfter ? (travel + 'px') : '0px');
      }
    }

    // Initial state: show Problem
    setState(false);

    button.addEventListener('click', function () {
      var showAfter = button.getAttribute('aria-pressed') !== 'true';
      setState(showAfter);
    });

    // Re-compute travel on resize for responsive width (clamp())
    window.addEventListener('resize', function () {
      var pressed = button.getAttribute('aria-pressed') === 'true';
      // re-apply transform so knob remains at correct end after width changes
      var knob = button.querySelector('.card__floating-toggle__knob');
      if (knob) {
        var travel = knobTravelPx();
        knob.style.setProperty('--knob-x', pressed ? (travel + 'px') : '0px');
      }
    }, { passive: true });

    button.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        button.click();
      }
    });
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-before-after-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Shopify editor/sections events
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });
})();
